var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgReportsCircle = props => /*#__PURE__*/React.createElement("svg", _extends({
  width: 174,
  height: 174,
  viewBox: "0 0 174 174",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M86.9999 171.167C40.516 171.167 2.83325 133.484 2.83325 87C2.83325 40.516 40.516 2.83334 86.9999 2.83334C133.484 2.83334 171.167 40.516 171.167 87C171.167 133.484 133.484 171.167 86.9999 171.167ZM0.333252 87C0.333252 39.1353 39.1352 0.333344 86.9999 0.333344C134.865 0.333344 173.667 39.1353 173.667 87C173.667 134.865 134.865 173.667 86.9999 173.667C39.1352 173.667 0.333252 134.865 0.333252 87ZM105.633 117.333H117.333V68.8H105.633V117.333ZM80.0666 117.333H91.7666V48H80.0666V117.333ZM54.4999 117.333H66.1999V82.6667H54.4999V117.333Z",
  fill: "#0FB878"
})));
export { SvgReportsCircle as ReactComponent };
export default __webpack_public_path__ + "086ad4975e365569283323881f6eebf7.svg";